var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"24f05949a6fd8e5b2688b34934e8a319680aadb3"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const IS_LOCALHOST =
  process.env.IS_LOCALHOST === 'true' ||
  process.env.NEXT_PUBLIC_IS_LOCALHOST === 'true';

Sentry.init({
  dsn:
    SENTRY_DSN ||
    'https://c94a8d35c38b4800923dd2eddb834cf7@o4504738609889280.ingest.sentry.io/4504754418417664',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,

  enabled: !IS_LOCALHOST,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
